export const REPAIR_SERVICE_URL = process.env.REPAIR_SERVICE_URL;
export const STRAPI_URL = process.env.STRAPI_URL;
